import * as $loading from './_loading'
import * as $help from './help'

var options: any

export function init($options: any): void {
    options = $options

    $help.tooltips.initializeTooltips($('.' + options.pageName))

    $('.' + options.pageName + ' .bcfla-th-sortable').click(function () {
        getVehiclesList(1, $(this).attr('data-sort'))
    })
}

export function getVehiclePage(page: number) {
    getVehiclesList(page, options.sort)
}

function getVehiclesList(page: number, sort: string) {
    $loading.show('Laddar fordon...')
    $('.' + options.pageName + '')
        .parent()
        .load(
            '/Vehicle/ListVehiclesForOwnerPaged?id=' +
                options.ownerId +
                '&sort=' +
                sort +
                '&page=' +
                page,
            function () {
                $loading.hide()
            }
        )
}
